export default "__VITE_ASSET__BafWqQor__"